import { useState, useCallback } from 'react'
import MojeProjektyService from '@/services/MojeProjektyService'

export default function useMyProjectsData() {
	const [data, setData] = useState([])
	const [loading, setLoading] = useState(true)
	const [loadingMore, setLoadingMore] = useState(false)
	const [error, setError] = useState(null)
	const [totalCount, setTotalCount] = useState(0)
	const [hasMore, setHasMore] = useState(false)
	const [filters, setFilters] = useState({})
	const [sortColumn, setSortColumn] = useState('created')
	const [sortDirection, setSortDirection] = useState('desc')
	const [limit, setLimit] = useState(50)

	const loadData = useCallback(async () => {
		setLoadingMore(prevLoadingMore => {
			if (!prevLoadingMore) setLoading(true)
			return prevLoadingMore
		})
		setError(null)

		const searchText = `${filters.searchText || ''}`.trim()
		const requestOptions = {
			limit,
			sortColumn,
			sortDirection,
			filters: {
				status: filters.status || null,
				placowkaId: filters.placowkaId || null,
				trainerId: filters.trainerId || null,
			},
		}
		const result = searchText
			? await MojeProjektyService.search(searchText, requestOptions)
			: await MojeProjektyService.getAll(requestOptions)

		if (result.error) {
			setError(result.error)
			setData([])
			setTotalCount(0)
			setHasMore(false)
		} else {
			setData(result.data)
			setTotalCount(result.totalCount)
			setHasMore(result.hasMore)
		}

		setLoading(false)
		setLoadingMore(false)
	}, [limit, sortColumn, sortDirection, filters])

	const handleLoadMore = useCallback(() => {
		if (hasMore && !loadingMore) {
			setLimit(prev => prev + 50)
			setLoadingMore(true)
		}
	}, [hasMore, loadingMore])

	const setSorting = useCallback((column, direction) => {
		setSortColumn(column)
		setSortDirection(direction)
	}, [])

	const updateFilters = useCallback(newFilters => {
		setFilters(prevFilters => ({ ...prevFilters, ...newFilters }))
	}, [])

	const clearError = useCallback(() => {
		setError(null)
	}, [])

	return {
		data,
		loading,
		loadingMore,
		error,
		totalCount,
		hasMore,
		loadData,
		handleLoadMore,
		setSorting,
		updateFilters,
		sortColumn,
		sortDirection,
		searchQuery: filters.searchText || '',
		clearError,
	}
}
